import { EffectsCommandMap } from 'dva';
import type { ChangeAction, OnMount_Page_Action, OnUnmount_Page_Action } from './types';
import { initialState } from './initialState';

export const pageEffects = {
  *onMount_Page({}: OnMount_Page_Action, {}: EffectsCommandMap) {},
  *onUnmount_Page({}: OnUnmount_Page_Action, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: initialState,
    });
  },
};
